import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

export default class Commons {
    successes: Array<any> = [];
    errors: Array<any> = [];
    toastr: ToastrService;
    translate: TranslateService;

    constructor(toastr, translate) {
        this.toastr = toastr;
        this.translate = translate
    }

    save() {
        console.error('Save is not implemented!')
    }

    clearNotifications() {
        this.errors = [];
        this.clearSuccesses();
        return this;
    }

    clearSuccesses() {
        this.successes = [];
        return this;
    }

    addError(error: string) {
        if (this.errors.indexOf(error) === -1) {
            this.errors.push(error)
        }
        this.translate.getTranslation(this.translate.currentLang).subscribe((translation) => {
            this.toastr.error(translation[error] ? translation[error] : error)
        }, err => this.errorHandler(err));
    }

    addSuccess(success: string) {
        this.successes.push(success);
        this.translate.getTranslation(this.translate.currentLang).subscribe((translation) => {
            this.toastr.success(translation[success] ? translation[success] : success)
        }, err => this.errorHandler(err));
    }

    errorHandler(err) {
        try {
            const parsedBody = JSON.parse(err._body);
            const errParsed = parsedBody.error;
            if (errParsed === 'Signature does not mach, probabaly logout - login needed' ||
                errParsed === 'Signature does not mach, probably logout - login needed' ||
                errParsed === 'This token has been invalidated') {
                window.location.href = '/login';
            } else {
                if (!errParsed) {
                    if (parsedBody.message) {
                        this.addError(parsedBody.message);
                    }
                } else {
                    this.addError(errParsed);
                }
            }
        } catch (e) {
            if (err._body) {
                this.addError(err._body)
            } else if (err.status === 0) {
                this.addError('Backend server down or no internet connection');
            } else {
                this.addError(err.message || "Technical problem")
            }
		}
    }
}
